<div class="app-shell" [attr.data-global-loading]="(isGlobalLoading$ | async) ? 'true' : 'false'">
  <router-outlet></router-outlet>

  <div
    *ngIf="isGlobalLoading$ | async"
    class="global-loader-overlay"
    aria-live="polite"
    aria-label="Loading">
    <owc-progress-spinner [size]="'xxLarge'" [mode]="'indeterminate'"></owc-progress-spinner>
  </div>
</div>



